import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";

import "../ButtonLogin/styles.css";
import "./styles.css";

import ButtonLogin from "../ButtonLogin";

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [
    { href: "#funcionalidades", label: "Funcionalidades" },
    { href: "#video", label: "Demonstracao" },
    { href: "#planos", label: "Planos" },
    { href: "#faq", label: "FAQ" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isMenuOpen) {
      return undefined;
    }

    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMenuOpen]);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  const handleCloseMenu = () => setIsMenuOpen(false);

  return (
    <header className="section-header">
      <nav
        className={`navbar-premium ${isScrolled ? "navbar-scrolled" : ""}`}
      >
        <div className="container presentation-nav-shell px-3 px-sm-4 px-lg-5">
          <div className="navbar-layout">
            <Link className="navbar-brand-link" to="/" onClick={handleCloseMenu}>
              <p className="easy-title mb-0 fw-bold">
                easy<span className="navbar-brand-accent"> VOG</span>
              </p>
            </Link>

            <button
              type="button"
              className="navbar-toggle d-lg-none"
              onClick={() => setIsMenuOpen((current) => !current)}
              aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
              aria-expanded={isMenuOpen}
              aria-controls="navbar-menu-panel"
            >
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>

            <div
              id="navbar-menu-panel"
              className={`navbar-shell ${isMenuOpen ? "is-open" : ""}`}
            >
              <div className="navbar-center">
                <ul className="navbar-links mb-0">
                  {navLinks.map((link) => (
                    <li key={link.href} className="navbar-link-item">
                      <a
                        className="navbar-link fw-semibold"
                        href={link.href}
                        onClick={handleCloseMenu}
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="navbar-actions">
                <div className="navbar-login-wrap">
                  <ButtonLogin />
                </div>
              </div>
            </div>
          </div>
        </div>

        {isMenuOpen && (
          <button
            type="button"
            className="navbar-backdrop d-lg-none"
            onClick={handleCloseMenu}
            aria-label="Fechar menu"
          />
        )}
      </nav>

      <a
        href="https://api.whatsapp.com/send?l=pt_br&amp;phone=+5551992542818&amp;text=Gostaria de informações sobre o EASYVOG!"
        target="_blank"
        rel="noreferrer"
        className="floating-whatsapp"
        aria-label="Atendimento via WhatsApp"
      >
        <button className="wh-ap-btn" type="button"></button>
      </a>
    </header>
  );
}

export default Navbar;
